module.exports = __webpack_public_path__ + "static/media/sendTextMessageSound.b82c2913.wav";